module.exports = __webpack_public_path__ + "static/img/banner1.52ca3490.png";